<template>
	<div>
		<div class="border-divisor-up"></div>
		<div class="row">
			<inline-alert-component v-if="seenAlert" type="primary" message="Informações"/>
		</div>
		<div class="row state-overview" v-if="at_pauses.geral">
			<div class="col-lg-4 col-sm-7">
				<section class="card" style="margin-bottom: 0 !important;">
					<div class="icons gray">
						<i class="fas fa-phone-alt"/>
					</div>
					<div class="titles">
						<h1 class="count">{{ at_pauses.geral.total }}</h1>
						<p>Total de Pausas</p>
					</div>
				</section>
			</div>
			<div class="col-lg-4 col-sm-7">
				<section class="card" style="margin-bottom: 0 !important;">
					<div class="icons gray">
						<i class="fas fa-clock"/>
					</div>
					<div class="titles">
						<h1 class="count2">{{ at_pauses.geral.tma | moment }}</h1>
						<p>Tempo Médio</p>
					</div>
				</section>
			</div>
			<div class="col-lg-4 col-sm-7">
				<section class="card" style="margin-bottom: 0 !important;">
					<div class="icons gray">
						<i class="fas fa-clock"/>
					</div>
					<div class="titles">
						<h1 class="count3">{{ at_pauses.geral.tempo_max | moment }}</h1>
						<p>Maior Pausa</p>
					</div>
				</section>
			</div>
		</div>

		<div class="row state-overview">
			<div class="col" v-for="(pausas, key) in at_pauses.pausas" :key="key">
				<section class="card mb-3">
					<div class="card-header text-white" :style="{backgroundColor: gera_cor()}">{{ key }}</div>
					<div class="card-body text-black-50">
						<div style="text-align: center">
							<h5 class="card-title">Quantidade:</h5><h6 class="card-text">{{ pausas.quantidade }}</h6>
							<h5 class="card-title">Tempo Total:</h5><h6 class="card-text">{{ pausas.tma | moment  }}</h6>
						</div>
					</div>
				</section>
			</div>
		</div>
		<div class="border-divisor-down"></div>
	</div>
</template>

<script>
    export default {
		name: "Pauses",

        data() {
            return {
				dtPauses: null,
                seenAlert: true,
				at_pauses: []
            }
		},

        methods: {
            pauses() {
				this.seenAlert = true;
				const form = $('#filter').serialize();
                axios.get(`reports/card_pauses/?${form}`)
                    .then(response => {
						this.seenAlert = false;
                        this.at_pauses = response.data;
                    }).catch(error => {
                    console.error(error)
                })
			},

            gera_cor(){
                var color = Math.floor(Math.random() * Math.pow(256, 3)).toString(16);
                while(color.length < 6) {
                    color = "0" + color;
                }
                return "#" + color;
			},

			mountData() {
				this.pauses();
			}
		},

		watch: {
			dates() {
				this.mountData();
			}
		},

		mounted() {
			this.mountData();
		},

		filters: {
  			moment: function (date) {
				return moment.utc(date * 1000).format('HH:mm:ss');
			}
		}
}
</script>

<style scoped>
	/*cards*/
	.border-divisor-up {
		margin-top: 2rem;
		border: 0;
		border-top: 1px solid rgba(0, 0, 0, 0.1);
	}
	.border-divisor-down {
		margin-bottom: 2rem;
		border: 0;
		border-top: 1px solid rgba(0, 0, 0, 0.1);
	}
	.state-overview .card {
		display: block;
		margin-bottom: 2rem;
		margin-top: 2rem;
		border: none;
	}
	.state-overview .gray {
		background: #999999;
	}
	.state-overview .terques {
		background: #4cd137;
	}
	.state-overview .red {
		background: #c23616;
	}
	.state-overview .blue {
		background: #1c869a;
	}
	.state-overview .orange {
		background: #ffa502;
	}
	.state-overview .symbol {
		/*width: 60px;*/
		height: 60px;
		border-radius: 4px 0 0 4px;
		padding: 17px 17px;
	}
	.state-overview .symbol i {
		color: #fff;
		font-size: 25px;
	}
	.state-overview .symbol, .state-overview .value {
		display: inline-block;
	}
	.state-overview .value {
		padding-top: 8px;
		text-align: right;
		padding-right: 8px;
	}
	.state-overview .value {
		float: right;
	}
	.state-overview .value h1 {
		font-size: 1.1rem;
		font-weight: 300;
	}
	.state-overview .value h1, .state-overview .value p {
		margin: 0;
		padding: 0;
		color: #7b7c80;
	}
	.state-overview .icons {
		width: 43px;
		height: 43px;
		border-radius: 4px 0 0 4px;
		padding: 12px 13px;
	}
	.state-overview .icons i {
		color: #fff;
		font-size: 17px;
	}
	.state-overview .icons, .state-overview .titles {
		display: inline-block;
	}
	.state-overview .titles {
		padding-top: 3px;
		text-align: right;
		padding-right: 4px;
	}
	.state-overview .titles {
		float: right;
	}
	.state-overview .titles h1, .state-overview .titles p {
		margin: 0;
		padding: 0;
		color: #7b7c80;
		font-size: 0.9rem;
		font-weight: 300;
	}
</style>
